import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Modal from "Components/Modal/Modal";
import ModalConfirm from "Components/Modal/ModalConfirm";
import { globalMessage } from "Components/New/GlobalMessaging/GlobalMessaging";
import localize from "helpers/localize";
import restHelper from "helpers/restHelper";
import React, { Fragment, PureComponent } from "react";
import { Helmet } from "react-helmet";
import ContainerHeader from "../../../../../Components/ContainerHeader";
import List from "../../../../../Components/List/List";
import ModifyPermission from "../../../../Permissions/ModifyPermission";
import Navbar from "../../Navbar";
import EditToken from "../EditToken";
import TokenCreate from "./TokenCreate";
import TokenRangeDelete from "./TokenRangeDelete";

class TokensList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      keyword: null,
      search: null,
      filters: null,
      perPage: null,
      open: false,
      openCreate: false,
      openRangeDeleteModal: false,
      loadingCreate: false,
      loadingRangeDelete: false
    };
    this.tokenCreate = React.createRef();
    this.tokenRangeDelete = React.createRef();
    this.modal = null;
  }

  getList = (page, keyword, sort, filters, perPage) => {
    this.setState({
      page,
      keyword,
      sort,
      filters,
      perPage
    });
    return this.props.getList(page, keyword, sort, filters, perPage);
  };

  handleRequestClose = () => {
    this.setState({ open: false });
    this.refreshList();
  };

  refreshList = () => {
    const { page, keyword, sort, filters, perPage } = this.state;
    this.getList(page, keyword, sort, filters, perPage);
  };

  customButtons = () => {
    return (
      <Fragment>
        <ModifyPermission module="tokens">
          <div className="col-auto mr-auto">
            <Button
              color="primary"
              onClick={() => this.setState({ open: true })}
            >
              {localize("tokens", "Token import")}
            </Button>
            <Button color="primary" onClick={this.openCreateModal}>
              {localize("tokens", "Létrehozás")}
            </Button>
            <Button color="primary" onClick={this.openRangeDeleteModal}>
              {localize("tokens", "Tartomány törlése")}
            </Button>
          </div>
        </ModifyPermission>
      </Fragment>
    );
  };

  openCreateModal = () => {
    this.setState({ openCreate: true });
  };

  closeCreateModal = () => {
    this.setState({ openCreate: false });
  };
  openRangeDeleteModal = () => {
    this.setState({ openRangeDeleteModal: true });
  };

  closeRangeDeleteModal = () => {
    this.setState({ openRangeDeleteModal: false });
  };

  acceptCreateModal = () => {
    if (
      this.tokenCreate &&
      this.tokenCreate.current &&
      this.tokenCreate.current.state.rows
    ) {
      /*const rows = this.tokenCreate.current.state.rows.map(row => {
        return {
          ...row,
          ap_filter:
            row.ap_filter && Array.isArray(row.ap_filter)
              ? row.ap_filter.join(";")
              : null
        };
      });*/
      const errors = this.tokenCreate.current.getErrors();
      if (errors) {
        console.log("ERROR", errors);
        return;
      }

      if (this.tokenCreate.current.needConfirm()) {
        this.modal
          .open(
            localize("basic", "Megerősítés"),
            localize(
              "tokens",
              "A lista 50 darabszám feletti tartományt tartalmaz. Biztosan folytatja?"
            ),
            null,
            localize("basic", "Igen"),
            localize("basic", "Mégsem")
          )
          .then(() => {
            this.saveTokens();
            this.modal.close();
          });
      } else {
        this.saveTokens();
      }
    }
  };
  acceptRangeDeleteModal = () => {
    if (
      this.tokenRangeDelete &&
      this.tokenRangeDelete.current //&&
      //this.tokenRangeDelete.current.state.value
    ) {
      /*const rows = this.tokenCreate.current.state.rows.map(row => {
        return {
          ...row,
          ap_filter:
            row.ap_filter && Array.isArray(row.ap_filter)
              ? row.ap_filter.join(";")
              : null
        };
      });*/
      if (!this.tokenRangeDelete.current.validateValue()) {
        return;
      }
      if (this.tokenRangeDelete.current.needConfirm()) {
        this.modal
          .open(
            localize("basic", "Megerősítés"),
            localize(
              "tokens",
              "A tartomány 50 darabszám feletti tokenszámot tartalmaz. Biztosan törli?"
            ),
            null,
            localize("basic", "törlés"),
            localize("basic", "Mégsem")
          )
          .then(() => {
            this.deleteTokens();
            this.modal.close();
          });
      } else {
        this.deleteTokens();
      }
    }
  };

  deleteTokens = () => {
    //console.log("deleteTokens");

    this.setState({ loadingRangeDelete: true });
    const params = this.tokenRangeDelete.current.getValueParams();

    restHelper
      .remove("tokens", null, {
        start: params.start,
        end: params.end
      })
      .then(response => {
        this.setState({
          openRangeDeleteModal: false,
          loadingRangeDelete: false
        });
        globalMessage.success(localize("basic", "Sikeres törlés"));
        this.refreshList();
      })
      .catch(() => {
        this.setState({ loadingRangeDelete: false });
      });
  };

  saveTokens = () => {
    this.setState({ loadingCreate: true });
    restHelper
      .create("tokens", "TokenImportForm", {
        rows: this.tokenCreate.current.transformRows()
      })
      .then(response => {
        this.setState({ openCreate: false, loadingCreate: false });
        globalMessage.success(localize("basic", "Sikeres létrehozás"));
        this.refreshList();
      })
      .catch(() => {
        this.setState({ loadingCreate: false });
      });
  };

  render() {
    const {
      openCreate,
      loadingCreate,
      openRangeDeleteModal,
      loadingRangeDelete
    } = this.state;
    return (
      <div className="animated slideInUpTiny animation-duration-3">
        <Helmet>
          <title>{localize("tokens", "Token adatok")}</title>
        </Helmet>
        <Navbar {...this.props} />
        <ContainerHeader title={localize("tokens", "Token adatok")} />
        <Modal
          open={openCreate}
          loading={loadingCreate}
          title={localize("tokens", "Tokenek hozzáadása")}
          //overflowVisibleBody
          maxWidth="lg"
          onAccept={this.acceptCreateModal}
          onCancel={this.closeCreateModal}
          onClose={this.closeCreateModal}
          disableIcon
          keepMounted={false}
          positionTop
        >
          <TokenCreate ref={this.tokenCreate} />
          <div style={{ height: 300 }} />
        </Modal>
        <Modal
          open={openRangeDeleteModal}
          loading={loadingRangeDelete}
          title={localize("tokens", "Tartomány törlése")}
          //overflowVisibleBody
          //maxWidth="lg"
          yesText={localize("basic", "Törlés")}
          onAccept={this.acceptRangeDeleteModal}
          onCancel={this.closeRangeDeleteModal}
          onClose={this.closeRangeDeleteModal}
          disableIcon
          keepMounted={false}
          //positionTop
        >
          <TokenRangeDelete ref={this.tokenRangeDelete} />
        </Modal>
        {this.state.open && (
          <Dialog
            open={this.state.open}
            maxWidth="md"
            fullWidth={true}
            scroll="body"
          >
            <DialogTitle>{localize("tokens", "Token import")}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <EditToken
                  {...this.props}
                  handleRequestClose={this.handleRequestClose.bind(this)}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleRequestClose.bind(this)}
                variant="contained"
                color="secondary"
                component="span"
              >
                {localize("basic", "Bezár")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        <ModalConfirm onRef={ref => (this.modal = ref)} />
        <List
          {...this.props}
          disableViewIcon={true}
          disableEditIcon={true}
          disabledCreate={true}
          customButtons={this.customButtons.bind(this)}
          getList={this.getList.bind(this)}
          reset={() => {}}
        />
      </div>
    );
  }
}

export default TokensList;
